export const AutocallerDemoLeadData = {
  firstName: "Tony",
  lastName: "Stark",
  address: "1 Malibu Mansions",
  phone: "+442081446244",
};
